import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import magnifying from '../assets/images/042-market-research1.svg';
import logo from '../assets/images/management-framework-blue.svg';
import { FrameworkCompositionModal } from '../components/framework/FrameworkCompositionModal';
import FrameworkItem from '../components/management/FrameworkItem';
import TabbedFrameworkView from '../components/management/TabbedFrameworkView';
import { selectCustomFrameworks, selectSelectedFrameworkId } from '../redux/reducers/frameworkReducer';

function FrameworkView() {
  const { t } = useTranslation();
  const customFrameworks = useSelector(selectCustomFrameworks);
  const selectedFrameworkId = useSelector(selectSelectedFrameworkId);
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const handleOpenCreation = () => {
    setCreateModalOpen(true);
  };

  const handleClose = () => {
    setCreateModalOpen(false);
  };

  return (
    <Container variant="baseView" subtype="activityManagement" disableGutters maxWidth={false}>
      {createModalOpen && <FrameworkCompositionModal handleClose={handleClose} />}
      {selectedFrameworkId === '' ? (
        <>
          <Stack spacing={3} sx={{ maxWidth: '900px' }}>
            <Stack direction="row" alignItems="center" spacing={3}>
              <img src={logo} alt="" />
              <Typography id='frameworks-title' variant="title">{t('framework.viewTitle')}</Typography>
            </Stack>
            <Typography variant="viewDesc">{t('framework.description')}</Typography>
          </Stack>
          {customFrameworks.length === 0 ? (
            <Container sx={{ mt: '32px' }} disableGutters>
              <Stack alignItems="center" spacing={4}>
                <Stack alignItems="center">
                  <Typography variant="noActivities">{t('framework.noFrameworkCreated.part1')}</Typography>
                  <Typography variant="noActivities">{t('framework.noFrameworkCreated.part2')}</Typography>
                </Stack>
                <img src={magnifying} width="200px" alt="" />
                <Button id='create-framework-first' variant="contained" onClick={() => handleOpenCreation()} endIcon={<AddIcon />}>
                  {t('framework.buttonCreateFirst')}
                </Button>
              </Stack>
            </Container>
          ) : (
            <Box sx={{ mt: '24px', maxWidth: '900px', height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="header">{t('framework.yourFrameworks')}</Typography>
                <Button id='create-framework' variant="contained" onClick={() => handleOpenCreation()} endIcon={<AddIcon />}>
                  {t('framework.buttonCreateNew')}
                </Button>
              </Stack>
              <Stack variant="elevated" spacing={3} sx={{ mt: '32px', overflow: 'auto', minWidth: 'max-content' }}>
                {customFrameworks.map((framework) => (
                  <FrameworkItem frameworkId={framework.id} key={framework.id} />
                ))}
              </Stack>
            </Box>
          )}
        </>
      ) : (
        <TabbedFrameworkView />
      )}
    </Container>
  );
}

export default FrameworkView;
